export default __webpack_public_path__ + "static/media/Apple.24b02f2d.svg";